import React, { useState } from 'react';
import { ActivityNotePanel } from '@/experiences/sales-portal/containers/activity-note-panel/activity-note-panel';
import { formatDateTimeWithYear } from '@/utils/date';
import { SalesPortalActivityNotesDocument } from '@/experiences/sales-portal/blocs/documents/sales-portal-activity-notes.generated';
import { useApolloClient } from '@apollo/client';
import { useProspectDetailLoader } from '@/experiences/sales-portal/domain/prospects/screens/prospect-detail/blocs/loaders/use-prospect-detail-loader';

interface ProspectActivityNotePanelContentProps {
  onClose: () => void;
  restaurantUUID: string;
  supplierUUID: string;
}

export const ProspectActivityNotePanelContent: React.FC<
  ProspectActivityNotePanelContentProps
> = ({ onClose, restaurantUUID, supplierUUID }) => {
  const [createdAt] = useState(() => formatDateTimeWithYear(new Date()));

  const { chatUUID } = useProspectDetailLoader({
    restaurantUUID,
    supplierUUID,
  });
  const apolloClient = useApolloClient();
  const refetchActivityNotes = () =>
    apolloClient.refetchQueries({
      include: [SalesPortalActivityNotesDocument],
      onQueryUpdated: (observableQuery) =>
        observableQuery.variables?.restaurantUUID === restaurantUUID &&
        observableQuery.variables?.supplierUUID === supplierUUID,
    });

  return chatUUID ? (
    <ActivityNotePanel
      chatUUID={chatUUID}
      createdAt={createdAt}
      onClose={onClose}
      onNoteSaved={() => refetchActivityNotes()}
    />
  ) : null;
};
